<div class="bgd"><router-outlet></router-outlet></div>
